import styled from "styled-components";
import { Modal } from "antd";

export const AlertPopUp = styled(Modal)`

@media (max-width: 767px) {
  .ant-modal {
    max-width: calc(100vw - 44px)!important;
    margin: 0 22px!important;
  }
}
  .ant-modal-title {
    font-family: ${props => props.theme.fontFamily.berkeleyStdBold};
    font-size: ${props => props.theme.fontSize.h4};
    color: #505050;
    text-align: center;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.17;
    letter-spacing: normal;
  }
  .ant-modal-content {
    border-radius: 0px;
  }
  .ant-modal-header {
    padding: 30px 0 13px 0;
    border: none;
    border-radius: 0;
    @media only screen and (max-width: 991.92px) {
      padding: 30px 0 15px 0;
    }
  }

  .ant-modal-body {
    font-family: ${props => props.theme.fontFamily.helveticaNeueBold};
    font-size: ${props => props.theme.fontSize.primary};
    color: #505050;
    padding: 24px 48px 30px 33px;
    text-align: center;
    @media only screen and (max-width: 991.92px) {
      max-height: 377px;
      overflow: scroll;
      border-top: 2px solid ${props => props.theme.border.filledTabsInactive};
      border-bottom: 2px solid ${props => props.theme.border.filledTabsInactive};
      padding: 19px 0px 0px 0px;
      margin: 0 27px 0 29px;
      &:after {
        background: linear-gradient(
            center bottom,
            #fff 0%,
            rgba(255, 255, 255, 0) 60%
          )
          repeat scroll 0 0 rgba(0, 0, 0, 0);
        bottom: 0;
        content: "";
        display: block;
        height: 30px;
        left: 0;
        pointer-events: none;
        position: fixed;
        width: 100%;
      }
    }
  }

  .ant-modal-footer {
    border-radius: 0;
    border: none;
    padding: 0px 0px 30px 0px;
    @media only screen and (max-width: 991.92px) {
      padding: 30px 0px 30px 0px;
    }
  }

  .ant-modal-footer > div {
    display: flex;
    flex-direction: column-reverse;
    align-items: center;
  }

  .ant-modal-footer > div > .ant-btn-primary {
    display: none;
  }

  .ant-modal-footer > div > .ant-btn-primary > span {
    color: #fff;
  }

  .ant-modal-footer > div > .ant-btn:first-child {
    border-radius: 0;
    font-family: ${props => props.theme.fontFamily.helveticaNeue};
    font-size: 18px;
    font-weight: 900;
    font-stretch: condensed;
    line-height: 1.67;
    width: 200px;
    height: 50px;
    color: ${props => props.theme.fontColors.color};
    border: 1px solid ${props => props.theme.fontColors.color};
    &:hover {
      border: 1px solid ${props => props.theme.fontColors.color};
    }
  }

  .ant-modal-footer > div > .ant-btn:first-child > span {
    color: ${props => props.theme.fontColors.color};
  }
`;

export const MessageAlert = styled(Modal)`
  .ant-modal-title {
    font-family: ${props => props.theme.fontFamily.berkeleyStdBold};
    font-size: ${props => props.theme.fontSize.h4};
    color: #505050;
    text-align: center;
  }
  .ant-modal-header {
    padding-top: 30px;
    border: none;
    border-radius: 0;
  }

  .ant-modal-body {
    font-family: ${props => props.theme.fontFamily.helveticaNeueBold};
    font-size: ${props => props.theme.fontSize.primary};
    color: #505050;
    text-align: center;
  }

  .ant-modal-footer {
    border-radius: 0;
    border: none;
  }

  .ant-modal-footer > div {
    display: flex;
    flex-direction: column-reverse;
    align-items: center;
  }

  .ant-modal-footer > div > .ant-btn-primary {
    width: 292px;
    border-radius: 0;
    height: 50px;
    font-family: ${props => props.theme.fontFamily.helveticaNeueCondensedBold};
    font-size: ${props => props.theme.fontSize.primary};
    line-height: 1.67;
    color: #fff;
    background-color: #006778;
  }

  .ant-modal-footer > div > .ant-btn-primary > span {
    color: #fff!;
  }

  .ant-modal-footer > div > .ant-btn:first-child {
    border-radius: 0;
    font-family: ${props => props.theme.fontFamily.helveticaNeue};
    font-size: ${props => props.theme.fontSize.primary};
    line-height: 1.67;
    color: #006778;
    border: 0px solid transparent;
    text-decoration: underline;
  }

  .ant-modal-footer > div > .ant-btn:first-child > span {
    color: #006778;
    text-decoration: underline;
  }
`;

export const AlertPopUpPrimary = styled(Modal)`
.ant-modal-title {
  font-family: ${props => props.theme.fontFamily.berkeleyStdBold};
  font-size: ${props => props.theme.fontSize.h4};
  color: #505050;
  text-align: center;
}
.ant-modal-header {
  padding-top: 30px;
  border: none;
  border-radius: 0;
}

.ant-modal-body {
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  font-size: ${props => props.theme.fontSize.primary};
  color: #505050;
  text-align: center;
}

.ant-modal-footer {
  border-radius: 0;
  border: none;
}

.ant-modal-footer > div {
  display: flex;
  flex-direction: column-reverse;
  align-items: center;
}

.ant-modal-footer > div > .ant-btn-primary {
  width: 292px;
  border-radius: 0;
  height: 50px;
  font-family: ${props => props.theme.fontFamily.helveticaNeueCondensedBold};
  font-size: ${props => props.theme.fontSize.primary};
  line-height: 1.67;
  color: #fff;
  background-color: #006778;
  @media only screen and (max-width: 576px) {
    width: 110px;
  }
}

.ant-modal-footer > div > .ant-btn-primary > span {
  color: #fff!;
}

.ant-modal-footer > div > .ant-btn:first-child {
  border-radius: 0;
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  font-size: ${props => props.theme.fontSize.primary};
  line-height: 1.67;
  color: #006778;
  border: 0px solid transparent;
  text-decoration: underline;
}

.ant-modal-footer > div > .ant-btn:first-child > span {
  color: #006778;
  text-decoration: underline;
}
`;
